 <div class="display-flex profile-header">
    <div class="float-left">
        <div class="title">
          <div class="back-button" (click)="backbutton()">
            &larr;
          </div>
          <div>
            {{ isEditMode ? 'Update Customer Profile' : 'Create Customer Profile' }}
            <p class="sub-header">{{ isEditMode ? 'Update existing customer profile for roleplay scenarios' : 'Add a new customer profile for roleplay scenarios' }}</p>
          </div>
        </div>
        
    </div>
    <div class="float-right">
      &nbsp;
    </div>
</div>

<div class="main-layout profile-wrapper">
  <div class="right-container">
    <div class="border-box-wrapper">
      <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
      <div class="border-box">
        <h2>Basic Information</h2>
        <div class="container">
          <!-- <form [formGroup]="profileForm" (ngSubmit)="onSubmit()"> -->
            <div class="basic-info">
              <div class="name-age-row">
                <div class="block">
                  <div class="cust">
                    <label class="labels" for="full_name">Customer Name <span class="required">*</span></label>
                    <input class="input-box" type="text" id="full_name" formControlName="full_name"
                      placeholder="Enter Customer Name">
                  </div>
                  <div *ngIf="profileForm.get('full_name').invalid && (profileForm.get('full_name').touched || isSubmitted)">
                    <span class="error-message">Full Name is required</span>
                  </div>
                </div>
                <div class="block">
                  <div class="cust">
                    <label class="labels" for="age">Age <span class="required">*</span></label>
                    <input class="input-box" type="number" id="age" formControlName="age" min="15" max="150" step="1"
                      (input)="filterNumeric($event)" placeholder="Enter Customer Age">
                    <div *ngIf="profileForm.get('age').invalid && (profileForm.get('age').touched || isSubmitted)">
                      <span class="error-message">Please enter an age between 15 and 110</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block">
                <div class="cust">
                  <label class="labels" for="occupation">Occupation<span class="required">*</span></label>
                  <input class="input-box occupation-w" type="text" id="occupation" formControlName="occupation"
                    placeholder="Enter Customer Occupation">
                </div>
                <div
                  *ngIf="profileForm.get('occupation').invalid && (profileForm.get('occupation').touched || isSubmitted)">
                  <span class="error-message">Occupation is required</span>
                </div>
              </div>
            </div>
          <!-- </form> -->
        </div>
      </div>
      <!-- second box -->
      <div class="border-box">
        <h2>Career Information</h2>
        <div class="container">
          <!-- <form [formGroup]="profileForm" (ngSubmit)="onSubmit()"> -->
            <div class="bottom-block">
              <div class="display-flex add-header">
                <div class="float-left"><label class="labels">Career Highlights <span class="required">*</span></label></div>
                <div class="float-right"><button type="button" [disabled]="isButtonDisabled" [ngClass]="{'disabled': isButtonDisabled}"
                    (click)="addCareerHighField()">+ Career Highlights</button></div>
              </div>

              <div formArrayName="career_high">
                <div *ngFor="let ctrl of career_high.controls; let i = index" class="career-high-row">
                  <div class="input-flex">
                    <input class="input-box" type="text" [formControlName]="i" placeholder="Add Career Highlight">
                    <span class="delete-item" *ngIf="career_high.length > 1" (click)="removeCareerHighField(i)" [class.disabled]="!ctrl.enabled">×</span>
                  </div>
                  <div *ngIf="ctrl.invalid && (ctrl.touched || isSubmitted)">
                    <span class="error-message">Career highlight is required</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom-block">
              <div class="display-flex add-header">
                <div class="float-left"><label class="labels">Professional Goals <span class="required">*</span></label></div>
                <div class="float-right"><button type="button" [disabled]="isButtonDisabled" [ngClass]="{'disabled': isButtonDisabled}"
                    (click)="addProffesionalGoalsField()">+ Add Goal</button></div>
              </div>
              <div formArrayName="professional_goals">
                <div *ngFor="let item of professional_goals.controls; let i=index;" [formGroupName]="i" class="bb-cl">
                  <div class="input-flex">
                    <input class="input-box" type="text" id="goal" formControlName="goal"
                      placeholder="Add New Professional Goal">
                    <span class="delete-item" *ngIf="i>0" (click)="removeGoals(i)" [class.disabled]="!item.enabled">×</span>
                  </div>
                  <div *ngIf="item.invalid && (item.touched || isSubmitted)">
                    <span class="error-message">Goal is required</span>
                  </div>
                </div>
              </div>
            </div>
          <!-- </form> -->
        </div>
      </div>
      <!-- end -->

      <!-- third box -->
      <div class="profile-btn-wrapper">
        <div class="container">
          <!-- <form [formGroup]="profileForm" (ngSubmit)="onSubmit()"> -->
            <div class="buttons-container">
              <div class="display-flex">
                <div class="float-left">
                  <button type="button" class="bttn btn-white-bdr" (click)="backbutton()">Cancel</button>
                </div>
                <div class="float-right">
                  <!-- First line of buttons: Cancel and Create -->
                  <div class="button-line">
                    <button type="button" class="bttn btn-red-bdr" (click)="cancel()"
                      *ngIf="!isEditMode">Reset Form</button>
                    <button type="submit" class="bttn" *ngIf="!isEditMode">Create Profile</button>
                  </div>
                  <!-- Second line of buttons: Edit, Delete, and Save -->
                  <div class="button-line">
                    <button type="button" class="bttn btn-white-bdr" *ngIf="isEditMode"
                      (click)="onEditEnable()">Edit Profile</button>
                    <button type="button" class="bttn btn-white-bdr" *ngIf="isEditMode"
                      (click)="deleteProfile()">Delete</button>
                    <button type="button" class="bttn" *ngIf="isEditMode" [disabled]="isButtonDisabled"
                      [ngClass]="{'disabled': isButtonDisabled}" (click)="onEdit()">
                      Save
                    </button>
                  </div>
                </div>
              </div>
              
            </div>
          <!-- </form> -->
        </div>
      </div>
      <!-- end -->
      </form>
    </div>
  </div>

  <!-- Move this left-container section to the right side -->
  <div class="left-container avatar-section">
    <div class="border-box">
      <h2><img src="../../../assets/images/avatar-user.svg" alt="Avatar User" width="20" height="20" /> Avatar Selection</h2>
      <div class="avatar-container">
        <!-- avatar options start -->
        <div class="container">
          <div class="inner-container">
            <div class="title">
              <div class="inner-block">
                <div class="doctor-big">
                  <div class="left-arrow">
                    <div class="left-arrow-container" (click)="previousProfile()" *ngIf="currentProfileId>0">
                      <img src="../../../assets/images/fluent_arrow-up-12-regular.svg" alt="Carousel arrow left" width="8" />
                    </div>
                  </div>
                  <div class="profile-big">
                    <img [src]="profiles?.[currentProfileId]?.avatar_url" alt="Customer" />
                  </div>
                  <div class="avatar-dots" *ngIf="profiles?.length > 1">
                    <span
                      class="avatar-dot"
                      *ngFor="let profile of profiles; let i = index"
                      [class.active]="i === currentProfileId"
                      (click)="selectProfile(i)"
                      role="button"
                      tabindex="0"
                      [attr.aria-label]="'Select avatar ' + (i + 1)"
                    ></span>
                  </div>
                  <div class="right-arrow" *ngIf="currentProfileId < (profiles?.length ?? 0) - 1">
                    <div class="right-arrow-container" (click)="nextProfile()">
                      <img src="../../../assets/images/fluent_arrow-up-12-regular.svg" alt="Carousel arrow right" width="8" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Second block -->
    <div class="border-box">
      <h2>Voice Settings</h2>
      <div class="nextDiv voice-settings">
        <div *ngIf="showVoiceOptions">
          <div class="section voice-type">
            <label class="labeltext">Voice Type:</label>
            <div class="label-row">
              <button class="bttn btn-white-bdr" [disabled]="true" [ngClass]="{'disabled': isButtonDisabled, 'selected': selectedVoiceType === 'male'}" 
                (change)="onSelectionChange()" name="voiceType" value="male">Male</button>
              <button class="bttn btn-white-bdr" [disabled]="true" [ngClass]="{'disabled': isButtonDisabled, 'selected': selectedVoiceType === 'female'}" 
                (change)="onSelectionChange()" name="voiceType" value="female">Female</button>
            </div>
          </div>
          <div class="section choose-voice">
            <label class="labeltext" for="voiceDropdown">Choose Voice:</label>
            <div class="label-row">
              <!-- <app-select [field]="" formControlName=""></app-select> -->
              <select id="voiceDropdown" class="voiceDrop" [(ngModel)]="selectedVoice" [disabled]="isButtonDisabled"
                [ngClass]="{'disabled': isButtonDisabled}">

                <option *ngFor="let voice of avatarVoiceList" [value]="voice.id">{{ voice.display_name
                  }}</option>
              </select>

              <button class="btn-play" (click)="playSampleVoice()" [disabled]="isButtonDisabled"
                [ngClass]="{'disabled': isButtonDisabled}">
                <img src="../../../assets/images/play-button.svg" alt="Play sample" width="40" height="40" />
              </button>
            </div>
          </div>
        </div>
        <p class="paraQueLite">Preview the voice before saving</p>
      </div>
    </div>
    <!-- end -->
  </div>
</div>